import EnumDataSource from "utils/enum-data-source.util";

export const REFUND_REASON_RETURN = 1;
export const REFUND_LOAN_RETURN = 2;
export const REFUND_OVERPAYMENT = 3;
export const REFUND_INSURANCE_REIMBURSEMENT = 4;

export const refundReasonTypes = {
  [REFUND_REASON_RETURN]: "Return",
  [REFUND_LOAN_RETURN]: "Loan Return",
  [REFUND_OVERPAYMENT]: "Overpayment",
  [REFUND_INSURANCE_REIMBURSEMENT]: "Insurance Reimbursement",
};

export const REFUND_REASON_TYPES = new EnumDataSource(refundReasonTypes);
